<template>
  <div style="background-color: #f5f5f5; height: 100vh">
    <van-nav-bar
      title="疑问解答"
      style="background: linear-gradient(to right, #75b9ff, #1b8bff)"
      left-arrow
      @click-left="onClickLeft"
    />
    <div style="margin: 10px; text-align: left">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="商品下单后，怎么查询订单？" name="1">
          商城首页，点击查询订单按钮，输入下单手机号，点击发送验证
          码，在输入框内输入验证码，点击确认查询即可
        </van-collapse-item>
      </van-collapse>
      <van-collapse style="margin-top: 10px" v-model="activeNames">
        <van-collapse-item title="商品下单后，怎么联系客服？" name="2">
          商城首页，点击联系客服按钮，联系客服后，给客服发送消息即
          可联系到客服！
        </van-collapse-item>
      </van-collapse>
      <van-collapse style="margin-top: 10px" v-model="activeNames">
        <van-collapse-item title="商品下单后，一般多长时间发货？" name="3">
          一般商品在下单的48小时内都会发货，若未发货可以联系客服咨 询发货时间！
        </van-collapse-item>
      </van-collapse>
      <van-collapse style="margin-top: 10px" v-model="activeNames">
        <van-collapse-item title="商品下单后，可以申请退款吗？" name="4">
          商品下单后，可以联系商城客服退款，具体政策需要以商城客服 回复为准！
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return { activeNames: ["1"] };
    },
    created() {},
    mounted() {},
    methods: {
      onClickLeft() {
        history.back();
      },
    },
  };
</script>
<style lang="scss">
  .van-nav-bar .van-icon {
    color: #fff;
  }
  .van-nav-bar__title {
    color: #fff;
  }

  * {
    margin: 0;
    padding: 0;
  }
</style>

<style lang="scss" scoped></style>
